/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IAction {
        action: string;
        profileName: string;
        profileOptionName: string;
    }

    export class Action implements IAction {
        public action: string;
        public profileName: string;
        public profileOptionName: string;

        public static Empty(): Action {
            return new Action();
        }

        constructor() {
            // empty constructor
            this.action = 'update_profile'; // default value
            this.profileName = '';
            this.profileOptionName = '';
        }
    }
}